import { AUTH_REGISTER_PATH } from '../web-api/endpoints';
import { AuthRegisterView } from '../views/AuthRegisterView';
import { GtxPageWithoutStore } from 'gtx-react/components/GtxApp/GtxApp';

export const authRegisterPage: GtxPageWithoutStore = {
    container: AuthRegisterView,
    path: AUTH_REGISTER_PATH,
    header: false,
};
